module.exports = __webpack_public_path__ + "img/hotel.2f5ab69e.png";